import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface TransferErrorPopupData {
	message: string;
}

@Component({
	selector: 'app-transfer-error-popup',
	templateUrl: './transfer-error-popup.component.html',
	styleUrl: './transfer-error-popup.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class TransferErrorPopupComponent {
	public message: string;

	// Bound as a plain field, not a long inline translate-pipe expression: the template compiler
	// (preserveWhitespaces: false) collapses the whitespace around a wrapped multi-line
	// interpolation into a real leading/trailing space, which visibly shifted this title relative
	// to the content below it. Keeping the template expression short keeps it on one line.
	public header: string;

	constructor(
		public dialogRef: MatDialogRef<TransferErrorPopupComponent>,
		private translator: TranslateService,
		@Inject(MAT_DIALOG_DATA) data: TransferErrorPopupData,
	) {
		this.message = data.message;
		this.header = this.translator.instant('shared.components.transfer-error-popup.header');
	}

	closeDialog(): void {
		this.dialogRef.close();
	}
}
